<script setup>
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/vue";
import { ChevronDownIcon, TableCellsIcon } from "@heroicons/vue/24/solid";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  selectAllVisible: {
    type: Function,
    required: true,
  },
  selectAll: {
    type: Function,
    required: true,
  },
  selectionSize: {
    type: Function,
    required: true,
  },
  align: {
    type: String,
    required: false,
    default: "left",
  },
});
</script>

<template>
  <div
    class="relative inline-flex w-full items-center gap-2"
    :class="{
      'justify-start': props.align === 'left',
      'justify-center text-center': props.align === 'center',
      'justify-end': props.align === 'right',
    }"
  >
    <Listbox>
      <div class="relative">
        <ListboxButton
          class="flex h-6 items-center justify-between gap-2 rounded border border-gray-500 px-2 py-1 text-left text-xs duration-150 hover:bg-indigo-600 hover:text-white"
        >
          <TableCellsIcon class="size-4" />

          <template v-if="selectionSize() > 0">
            {{ selectionSize() }}
          </template>
          <template v-else> &nbsp; </template>

          <ChevronDownIcon class="size-4" />
        </ListboxButton>
      </div>

      <ListboxOptions
        class="absolute left-0 top-8 z-50 w-[240px] rounded bg-white py-2 drop-shadow-md"
      >
        <ListboxOption
          @click="selectAllVisible"
          class="cursor-pointer px-4 py-2 text-sm font-normal normal-case duration-150 hover:bg-gray-100"
        >
          {{ t("all.item.selectAllVisible") }}
        </ListboxOption>

        <ListboxOption
          @click="selectAll"
          class="cursor-pointer px-4 py-2 text-sm font-normal normal-case duration-150 hover:bg-gray-100"
        >
          {{ t("all.item.selectAll") }}
        </ListboxOption>
      </ListboxOptions>
    </Listbox>
  </div>
</template>
